
import { LocalVideoTrack, Room as TwilioRoom } from 'twilio-video';

export class ScreensharingHelper {
  screenTrack?: LocalVideoTrack;

  async startSharing(twilioRoom: TwilioRoom, onStop: ()=>void): Promise<'busy' | 'started' | 'failed'> {
    let existingScreenSharing = Array.from(twilioRoom.participants.values() ?? []).find(rp => rp.videoTracks.size > 0);;
    if (existingScreenSharing) {
      return 'busy';
    } else {
      try {
        let stream = await navigator.mediaDevices.getDisplayMedia();
        let track = new LocalVideoTrack(stream.getTracks()[0]);
        this.screenTrack = track;
        await twilioRoom.localParticipant.publishTrack(track);
        track.mediaStreamTrack.onended = () => { this.stopSharing(twilioRoom); onStop();};
        return 'started';
      } catch (error) {
        alert(error);
        return 'failed';
      }
    }
  }

  stopSharing(twilioRoom: TwilioRoom | undefined) {
    if (this.screenTrack) {
      this.screenTrack.stop();
      twilioRoom?.localParticipant.unpublishTrack(this.screenTrack);
      this.screenTrack = undefined;
    }
  }

  isSharing() {
    return !!this.screenTrack && this.screenTrack.isEnabled;
  }

}
